export default "__VITE_ASSET__DQUmJIAJ__"